import React, { useState, useEffect, useContext } from 'react';
import Header from '../../components/Header';
import { db } from '../../services/firebaseConnection';
import { collection, getDocs, deleteDoc, doc, getDoc } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { FiEdit2, FiPlus } from 'react-icons/fi';
import { FaRegTrashAlt } from "react-icons/fa";
import { GiFamilyHouse } from "react-icons/gi";
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/auth';

export default function Igreja() {
  const [igrejas, setIgrejas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'ascending' });

  const { user } = useContext(AuthContext); 
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const getIgrejaFromDatabase = async () => {
      try {
        const igrejaSnapshot = await getDocs(collection(db, 'Igreja'));
        const igrejaData = await Promise.all(
          igrejaSnapshot.docs.map(async docSnapshot => {
            const igreja = { id: docSnapshot.id, ...docSnapshot.data() };

            if (igreja.cidade) {
              const cidadeRef = doc(db, 'Cidade', igreja.cidade);
              const cidadeSnapshot = await getDoc(cidadeRef);
              igreja.cidade = cidadeSnapshot.exists() ? cidadeSnapshot.data().nome : 'N/A';
            }
            return igreja;
          })
        );

        setIgrejas(igrejaData);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao buscar igreja:', error);
        setLoading(false);
      }
    };

    getIgrejaFromDatabase();
  }, []);

  useEffect(() => {
    async function loadPermissions() {

      const storedUser = localStorage.getItem('@userLogado');
      if (!storedUser) {
        console.error('Usuário não encontrado no localStorage.');
        return;
      }

      const userData = JSON.parse(storedUser);
      const cargoId = userData?.cargo;

      if (!cargoId) {
        console.error('ID do cargo não encontrado no usuário.');
        return;
      }

      try {
        const cargoRef = doc(db, 'Cargo', cargoId);
        const cargoDoc = await getDoc(cargoRef);

        if (cargoDoc.exists()) {
          const cargoData = cargoDoc.data();

          setPermissions(cargoData.permissoes || []);
        } else {
          console.error('Documento do cargo não encontrado no Firestore.');
        }
      } catch (error) {
        console.error('Erro ao buscar permissões no Firestore:', error);
      }
    }

    loadPermissions();
  }, []);

  const hasPermission = (permission) => {
    return permissions.includes(permission);
  };

  const handleDelete = async (id) => {
    try {
      const igrejaRef = doc(db, 'Igreja', id);
      await deleteDoc(igrejaRef);
      toast.success('Igreja excluída com sucesso!');
      setIgrejas(igrejas.filter(igreja => igreja.id !== id));
    } catch (error) {
      console.error('Erro ao excluir igreja:', error);
      toast.error('Erro ao excluir igreja.');
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedIgrejas = React.useMemo(() => {
    let sortableIgrejas = [...igrejas];
    if (sortConfig.key) {
      sortableIgrejas.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableIgrejas;
  }, [igrejas, sortConfig]);

  const filteredIgrejas = sortedIgrejas.filter(igreja =>
    igreja.nome.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <Header />

      <div className="content">
        <div className="title-container">
          <div className="title-left">
            <GiFamilyHouse size={25} />
            <h1>Casas de Oração</h1>
          </div>
          <Link to="/igreja/new" className="title-link incluir">
            <FiPlus color="#FFF" size={25} />
            <span>Incluir Casa de Oração</span>
          </Link>
        </div>

        <div className="container dashboard">
          {loading && <span>Carregando Casas de Oração...</span>}
          {!loading && igrejas.length === 0 && <span>Nenhuma Casas de Oração encontrada...</span>}
        </div>

        <input
          type="text"
          className="filter-container"
          placeholder="Buscar por nome..."
          value={searchTerm}
          onChange={handleSearchChange}
        />

        {!loading && igrejas.length > 0 && (
          <table>
            <thead>
              <tr>
                <th onClick={() => handleSort('nome')}>Nome</th>
                <th onClick={() => handleSort('cidade')}>Cidade</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredIgrejas.map((igreja, index) => (
                <tr key={index}>
                  <td data-label="Nome">{igreja.nome}</td>
                  <td data-label="Cidade">{igreja.cidade || 'N/A'}</td>
                  <td data-label="Ação">
                    <Link
                      to={`/igreja/edit/${igreja.id}`}
                      className="action"
                      style={{ backgroundColor: '#03c9e9' }}
                    >
                      <FiEdit2 color="#FFF" size={17} />
                    </Link>
                    {hasPermission('deletar_itens') && (
                      <button
                        className="action"
                        style={{ backgroundColor: '#e90303' }}
                        onClick={() => handleDelete(igreja.id)}
                      >
                        <FaRegTrashAlt color="#FFF" size={17} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
